<template>
  <div class="interventions">
    <div class="header-intervention">
      <div class="header-info">
        Accueil
      </div>
    </div>
    <b-container class="account-content">
      <div class="inter">
        <div class="type" v-on:click="buttonTypeMenu('/interventions/postprodsav/open')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-code-fork" aria-hidden="true"></i>
            </div>
            <div class="texte">PostProd / SAV</div>
          </div>
        </div>
        <div class="type" v-on:click="buttonTypeMenu('/interventions/prod/open')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-cogs" aria-hidden="true"></i>
            </div>
            <div class="texte">Prod</div>
          </div>
        </div>
      </div>
      <div class="compte">
        <div class="type" v-on:click="buttonTypeMenu('/interventions/audit/open')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
            <div class="texte">Audit</div>
          </div>
        </div>
        <div class="type" v-on:click="buttonTypeMenu('/interventions/auditpm/open')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
            <div class="texte">Audit PM</div>
          </div>
        </div>
      </div>
      <div class="compte">
        <div class="type" v-on:click="buttonTypeMenu('/account')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-user" aria-hidden="true"></i>
            </div>
            <div class="texte">Mon compte</div>
          </div>
        </div>
        <div class="type" v-on:click="buttonTypeMenu('/testarbre')">
          <div class="content">
            <div class="icon">
              <i class="fa fa-tree" aria-hidden="true"></i>
            </div>
            <div class="texte">Test des arbres</div>
          </div>
        </div>
      </div>
      <div class="compte">
        <div class="type" v-on:click="logout">
          <div class="content">
            <div class="icon">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
            </div>
            <div class="texte">Déconnexion</div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('fr')
export default {
  name: 'Account',
  data () {
    return {
      account: {}
    }
  },
  methods: {
    buttonTypeMenu: function (status) {
      this.$router.push(status)
    },
    logout: function () {
      localStorage.removeItem('token')
      localStorage.removeItem('login')
      localStorage.removeItem('password')
      this.$router.push('/')
    }
  },
  mounted: function () {
  }
}
</script>
<style scoped>
  .account-content{
    overflow: scroll;
  }
  .header-info{
    display: inline-block;
    position: absolute;
    left: 16px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    top: 71px;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    text-align: center;
  }
  .inter{
    display: block;
    padding-top: 120px;
  }
  .inter > .type{
    display: inline-block;
    width: 49%;
    height: 110px;
    background: #ffffff;
    text-align: center;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    color: #444;
  }
  .inter > .type > .content{
    text-align: center;
  }

  .compte{
    display: block;
    padding-top: 20px;
  }
  .compte > .type{
    display: inline-block;
    width: 49%;
    height: 110px;
    background: #ffffff;
    text-align: center;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    color: #444;
  }
  .compte > .type > .content{
    text-align: center;
  }
  .icon{
    margin-top: 8px;
    color: rgb(230, 68, 68);
    font-size: 45px;
  }
  .texte{
    color: grey;
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue